export function createActionName(namespace: string, name: string): string {
  return `[${namespace}] ${name}`
}
